import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, Lock, Eye, EyeOff } from 'lucide-react';
import Header from './components/Header8';
import Footer from './components/Footer8';

const Login8 = () => {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({ email: '', password: '' });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        navigate('/template8');
    };

    const inputStyle = {
        width: '100%', padding: '14px 16px 14px 44px', backgroundColor: '#FDF2F8', border: '1px solid #F9A8D4', borderRadius: '8px',
        color: '#1A1A1A', fontSize: '14px', fontFamily: "'DM Sans', sans-serif", outline: 'none', transition: 'border-color 0.3s ease',
    };

    return (
        <>
            <style>{`@import url('https://fonts.googleapis.com/css2?family=Libre+Baskerville:wght@400;700&family=DM+Sans:wght@300;400;500;700&display=swap');
            .mehak-login-input:focus { border-color: #BE185D !important; }`}</style>
            <div style={{ fontFamily: "'DM Sans', sans-serif" }} className="min-h-screen bg-white">
                <Header />
                <main className="pt-20 min-h-screen flex">
                    {/* Left Side - Hero Image (Desktop Only) */}
                    <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden">
                        <img src="https://images.pexels.com/photos/2916387/pexels-photo-2916387.jpeg?auto=compress&cs=tinysrgb&w=1200" alt="Elegant fashion" className="absolute inset-0 w-full h-full object-cover" />
                        <div className="absolute inset-0" style={{ background: 'linear-gradient(to right, rgba(253,242,248,0.3) 0%, rgba(253,242,248,0.7) 70%, #FDF2F8 100%)' }} />
                        <div className="relative z-10 flex flex-col justify-center items-start p-16 max-w-lg">
                            <div className="w-12 h-1 rounded-full mb-6" style={{ backgroundColor: '#BE185D' }} />
                            <h2 style={{ fontFamily: "'Libre Baskerville', serif" }} className="text-4xl xl:text-5xl font-bold leading-tight mb-4" >
                                Welcome Back, Beautiful
                            </h2>
                            <p className="text-base leading-relaxed" style={{ color: '#6B7280' }}>
                                Sign in to explore our garden of handcrafted Indian fashion designed for the modern woman.
                            </p>
                        </div>
                    </div>

                    {/* Right Side - Login Form */}
                    <div className="flex-1 flex items-center justify-center px-6 py-12 lg:py-0" style={{ backgroundColor: '#FDF2F8' }}>
                        <div className="w-full max-w-md">
                            <div className="text-center mb-10">
                                <h1 onClick={() => navigate('/template8')} style={{ fontFamily: "'Libre Baskerville', serif" }} className="text-3xl font-bold cursor-pointer mb-3" >
                                    M<span style={{ color: '#BE185D' }}>E</span>HAK
                                </h1>
                                <h2 style={{ fontFamily: "'Libre Baskerville', serif" }} className="text-2xl font-bold mb-2">Sign In</h2>
                                <p className="text-sm" style={{ color: '#6B7280' }}>Access your account and exclusive collections</p>
                            </div>

                            <form onSubmit={handleSubmit} className="space-y-5">
                                <div className="relative">
                                    <Mail size={18} className="absolute left-4 top-1/2 -translate-y-1/2" style={{ color: '#BE185D' }} />
                                    <input name="email" type="email" value={formData.email} onChange={handleInputChange} placeholder="Email address" className="mehak-login-input" style={inputStyle} required />
                                </div>
                                <div className="relative">
                                    <Lock size={18} className="absolute left-4 top-1/2 -translate-y-1/2" style={{ color: '#BE185D' }} />
                                    <input name="password" type={showPassword ? 'text' : 'password'} value={formData.password} onChange={handleInputChange} placeholder="Password" className="mehak-login-input" style={{ ...inputStyle, paddingRight: '44px' }} required />
                                    <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-4 top-1/2 -translate-y-1/2" style={{ color: '#6B7280' }}>
                                        {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                    </button>
                                </div>
                                <div className="text-right">
                                    <button type="button" className="text-sm font-medium" style={{ color: '#BE185D' }}>Forgot password?</button>
                                </div>
                                <button type="submit" className="w-full py-4 rounded-lg text-sm font-semibold uppercase tracking-wider transition-all" style={{ backgroundColor: '#BE185D', color: '#FFFFFF' }}
                                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#9D174D'; }}
                                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#BE185D'; }}
                                >
                                    Sign In
                                </button>
                            </form>

                            <p className="text-center text-sm mt-8" style={{ color: '#6B7280' }}>
                                New to MEHAK?{' '}
                                <span onClick={() => navigate('/template8/signup')} className="font-semibold cursor-pointer" style={{ color: '#BE185D' }}>Create Account</span>
                            </p>
                        </div>
                    </div>
                </main>
            </div>
        </>
    );
};

export default Login8;
